type UtilityIcon = 'history' | 'medals' | 'vip' | 'settings' | 'restart'

const paths: Record<UtilityIcon, string> = {
  history: 'M3 3C6 2 9 3 11 4.5V21C8.5 19.5 6 19 3 20L1 19V4ZM13 4.5C15 3 18 2 21 3L23 4V19L21 20C18 19 15.5 19.5 13 21Z',
  medals: 'M6 2H18V4H22V8C22 11 20 13 17 13C16 15 14.5 16 13 16.5V19H17V22H7V19H11V16.5C9.5 16 8 15 7 13C4 13 2 11 2 8V4H6ZM4 6V8C4 9.5 5 10.5 6.5 11C6 9.5 6 8 6 6ZM18 6C18 8 18 9.5 17.5 11C19 10.5 20 9.5 20 8V6Z',
  vip: 'M2 5L7.5 9L12 2L16.5 9L22 5L20 18H4ZM4 20H20V23H4Z',
  settings: 'M9 1H15L16 4L18 5L21 5L24 10L22 12L22 14L23 17L20 21L17 20L15 21L14 24H9L8 21L6 20L3 21L0 17L2 14V12L0 10L3 5H6L8 4ZM12 8A4 4 0 1 0 12 16A4 4 0 1 0 12 8Z',
  restart: 'M12 3V0L7 4L12 8V5C16.4 5 20 8.6 20 13C20 17.4 16.4 21 12 21C8.3 21 5.2 18.5 4.3 15H1.2C2.2 20.2 6.7 24 12 24C18.1 24 23 19.1 23 13C23 6.9 18.1 3 12 3Z'
}

export function SolidUtilityIcon({ name }: { name: UtilityIcon }) {
  return <svg className="ui-icon solid-utility-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d={paths[name]} fillRule="evenodd" /></svg>
}
